import {FormGroup, NG_VALIDATORS, ValidationErrors, Validator} from "@angular/forms";
import {Directive, Input} from "@angular/core";
import {IdentityNumberValidator} from "./identity-number-validator";

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: '[identityNumberValidator]',
    providers: [{ provide: NG_VALIDATORS, useExisting: IdentityNumberValidatorDirective, multi: true }]
})
export class IdentityNumberValidatorDirective implements Validator {

    constructor() { }

    @Input('identityNumberValidator') identityNumberValidator: any[] = [];

    validate(formGroup: FormGroup): ValidationErrors {
        return IdentityNumberValidator(this.identityNumberValidator[0], this.identityNumberValidator[1], this.identityNumberValidator[2])(formGroup);
    }
}
